module.exports = __webpack_public_path__ + "static/media/arrow_down.82eac4d3.svg";